import { CustomError } from './custom-error';
import { CodeError } from '../constant/text.constant';

export class UserAlreadyExistsError extends CustomError {
  private static readonly CODE = CodeError.USER_ALREADY_EXISTS;

  constructor() {
    super(UserAlreadyExistsError.CODE);
  }
}
